/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestRequest
 */
export interface AccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestRequest
     */
    employer?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestRequest
     */
    requestedRoleId?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestRequest
     */
    requestedPermissionId?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestRequest
     */
    organizationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestRequest
     */
    acceptGdprRequirement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestRequest
     */
    foreignEmployerRequirement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestRequest
     */
    acceptOrganizationRequirement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestRequest
     */
    ignoreOrganizationRequirement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestRequest
     */
    requiresReasonForAsking?: boolean;
}

/**
 * Check if a given object implements the AccessRequestRequest interface.
 */
export function instanceOfAccessRequestRequest(value: object): value is AccessRequestRequest {
    return true;
}

export function AccessRequestRequestFromJSON(json: any): AccessRequestRequest {
    return AccessRequestRequestFromJSONTyped(json, false);
}

export function AccessRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'employer': json['employer'] === undefined ? undefined : json['employer'] === null ? null : json['employer'],
        'requestedRoleId': json['requestedRoleId'] === undefined ? undefined : json['requestedRoleId'] === null ? null : json['requestedRoleId'],
        'requestedPermissionId': json['requestedPermissionId'] === undefined ? undefined : json['requestedPermissionId'] === null ? null : json['requestedPermissionId'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'acceptGdprRequirement': json['acceptGdprRequirement'] == null ? undefined : json['acceptGdprRequirement'],
        'foreignEmployerRequirement': json['foreignEmployerRequirement'] === undefined ? undefined : json['foreignEmployerRequirement'] === null ? null : json['foreignEmployerRequirement'],
        'acceptOrganizationRequirement': json['acceptOrganizationRequirement'] === undefined ? undefined : json['acceptOrganizationRequirement'] === null ? null : json['acceptOrganizationRequirement'],
        'ignoreOrganizationRequirement': json['ignoreOrganizationRequirement'] === undefined ? undefined : json['ignoreOrganizationRequirement'] === null ? null : json['ignoreOrganizationRequirement'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
    };
}

export function AccessRequestRequestToJSON(json: any): AccessRequestRequest {
    return AccessRequestRequestToJSONTyped(json, false);
}

export function AccessRequestRequestToJSONTyped(value?: AccessRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'description': value['description'],
        'employer': value['employer'],
        'requestedRoleId': value['requestedRoleId'],
        'requestedPermissionId': value['requestedPermissionId'],
        'organizationId': value['organizationId'],
        'acceptGdprRequirement': value['acceptGdprRequirement'],
        'foreignEmployerRequirement': value['foreignEmployerRequirement'],
        'acceptOrganizationRequirement': value['acceptOrganizationRequirement'],
        'ignoreOrganizationRequirement': value['ignoreOrganizationRequirement'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
    };
}

